import { render } from "./TransferProject.vue?vue&type=template&id=6c71044b&ts=true"
import script from "./TransferProject.vue?vue&type=script&lang=ts"
export * from "./TransferProject.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__